import { T } from "../tokens";
import type { ReactNode } from "react";

interface Props {
  icon:     ReactNode;
  label:    string;
  active?:  boolean;
  count?:   number;
  onClick?: () => void;
}

export function NavItem({ icon, label, active, count, onClick }: Props) {
  return (
    <button
      onClick={onClick}
      style={{
        display: "flex", alignItems: "center", gap: "10px",
        width: "100%", padding: "9px 12px", borderRadius: "8px",
        background: active ? T.s3 : "transparent",
        border: active ? `1px solid ${T.b1}` : "1px solid transparent",
        color: active ? T.t0 : T.t2,
        fontSize: "13px", fontFamily: T.body, fontWeight: active ? 600 : 400,
        cursor: "pointer", transition: "all 0.12s ease",
        textAlign: "left",
      }}
      onMouseEnter={e => {
        if (!active) (e.currentTarget as HTMLElement).style.color = T.t1;
      }}
      onMouseLeave={e => {
        if (!active) (e.currentTarget as HTMLElement).style.color = T.t2;
      }}
    >
      <span style={{ fontSize: "15px", width: "18px", textAlign: "center" }}>{icon}</span>
      <span style={{ flex: 1 }}>{label}</span>
      {count != null && count > 0 && (
        <span style={{
          background: T.teal, color: T.cta, borderRadius: "99px",
          fontSize: "10px", fontFamily: T.mono, fontWeight: 600,
          padding: "1px 6px", minWidth: "18px", textAlign: "center",
        }}>{count > 99 ? "99+" : count}</span>
      )}
    </button>
  );
}
